import "core-js/modules/es.object.keys.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    inputProps: null
  },
  setup: function setup(__props) {
    var props = __props;
    var shape = ref(null);
    onMounted(function () {
      if (!shape.value || !props.inputProps) return;
      var input = shape.value.querySelector(".n-input__input-el");
      if (!input) return;
      var attributes = Object.keys(props.inputProps);
      input.setAttribute("inputmode", "numeric");

      for (var _i = 0, _attributes = attributes; _i < _attributes.length; _i++) {
        var name = _attributes[_i];
        input.setAttribute(name, props.inputProps[name]);
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "shape",
        ref: shape,
        class: "d-inline-block"
      }, [_renderSlot(_ctx.$slots, "default")], 512);
    };
  }
});